import React from 'react';

import {FormInput} from 'src/components/input';
import {ServerResponseHandler} from 'src/components/server-response-handler';
import {Skeleton} from 'src/components/skeleton';
import {CustomValidatedControl} from 'src/contexts/validation-context';
import {ACCESS_RIGHTS} from 'src/hooks/access-rights';

import {EzProxySkeleton} from './ez-proxy-skeleton';

import type {AccessRight} from 'src/hooks/access-rights/constants';
import type {Error} from 'src/openapi/admin/models/Error';
import type {ProxyLink} from 'src/openapi/admin/models/ProxyLink';

type Props = {
    isLoading: boolean,
    loadingError: Error | null,
    proxy: ProxyLink,
    onChange: (proxy: ProxyLink) => void,
    disabled?: boolean,
};

const SECTION_NAME = 'EZProxy URL';

export const EzProxySection: React.FC<Props> = ({isLoading, loadingError, proxy, onChange, disabled}) => (
    <Skeleton view={<EzProxySkeleton/>} shown={isLoading}>
        <ServerResponseHandler
            smallView={true}
            sectionName={SECTION_NAME}
            serverError={loadingError}
            accessRight={ACCESS_RIGHTS.ACCOUNT_SCREEN_VIEW as AccessRight}>
            <CustomValidatedControl name="ez-proxy">
                {error => (
                    <FormInput
                        maxLength={128}
                        value={proxy.value || ''}
                        placeholder="EZProxy URL"
                        onBlur={value => onChange({value})}
                        readOnly={disabled}

                        width={300}
                        label={SECTION_NAME}
                        valid={error ? !error : undefined}
                        description={error}
                    />
                )}
            </CustomValidatedControl>
        </ServerResponseHandler>
    </Skeleton>
);
